import React from "react";
import { Modal, Button } from "react-bootstrap";

/**
 * Confirm linking a person who already has a Jobvious account (409 USER_EXISTS)
 * instead of creating a duplicate. Shows only what the 409 carries — never the
 * person's other companies.
 *
 * Props:
 *   show       boolean
 *   message    full sentence from linkPromptMessage()
 *   busy       boolean — disables both buttons while the link is in flight
 *   onConfirm  () => void
 *   onCancel   () => void
 */
const LinkExistingUserModal = ({ show, message, busy = false, onConfirm, onCancel }) => (
  <Modal show={show} onHide={busy ? undefined : onCancel} centered>
    <Modal.Header closeButton={!busy}>
      <Modal.Title>This person already exists</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className="alert alert-info mb-0">{message}</div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onCancel} disabled={busy}>
        Cancel
      </Button>
      <Button variant="primary" onClick={onConfirm} disabled={busy}>
        {busy ? "Adding…" : "Add them"}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default LinkExistingUserModal;
